var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MuiChip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import { style, compose, bgcolor, borders } from '@material-ui/system';
import palette from '../palette';
var textColors = style({
    prop: 'textColor',
    cssProperty: 'color',
    themeKey: 'palette',
});
var StyledChip = styled(MuiChip)(compose(textColors, bgcolor, borders));
var ChipBgColors = {
    info: palette.grey[300],
    danger: palette.error.light,
    pending: palette.warning.light,
    active: palette.success.light,
    new: palette.success.main,
    filter: palette.grey[300],
};
var ChipTextColors = {
    info: palette.primary.dark,
    danger: palette.error.main,
    pending: palette.warning.main,
    active: palette.success.main,
    new: palette.success.contrastText,
    filter: palette.grey[900],
};
/**
 * Kareo wrapped component of the Material-UI Chip. The prop API has been limited to props defined in ChipProps.
 *
 * Chips are compact elements that represent an input, attribute, or action.
 *
 * Material-UI Chip: [Docs](https://v4.mui.com/components/chips/), [API](https://v4.mui.com/api/chip/)
 *
 * @storybook: [Chip](http://design.kareoprod.ent/design-system/?path=/story/components-data-display--chip)
 */
var Chip = React.forwardRef(function (_a, ref) {
    var _b = _a.type, type = _b === void 0 ? 'filter' : _b, props = __rest(_a, ["type"]);
    var bgColor = ChipBgColors[type];
    var textColor = ChipTextColors[type];
    return (React.createElement(StyledChip, __assign({ ref: ref, className: type, bgcolor: bgColor, textColor: textColor, variant: type === 'filter' ? 'outlined' : 'default', size: "medium" }, props)));
});
Chip.displayName = 'KareoChip';
export default Chip;
